// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const OpenWithIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="OpenWithIcon" ref={forwardedRef} {...props}>
      <path d="M3 10.993h6.006V17H7.504v-3.503l-3.237 3.238-1.062-1.062 3.178-3.178H3z" />
      <path d="M17 15.994a1 1 0 0 1-1 .999h-3.996a1 1 0 0 1-1-1v-3.997a1 1 0 0 1 1-1H16a1 1 0 0 1 .999 1zm-1.499-3.498h-2.998v2.998h2.998z" />
      <path d="M16 8.996a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-3.996a1 1 0 0 0-1 1v3.997a1 1 0 0 0 1 1zm-.499-1.499h-2.998V4.5h2.998z" />
      <path d="M8.007 8.996a1 1 0 0 0 .999-1V4a1 1 0 0 0-1-.999H4.01a1 1 0 0 0-1 1v3.997a1 1 0 0 0 1 1zm-.5-1.499H4.51V4.5h2.998z" />
    </SvgIcon>
  );
});

/**
 * Use to open the intent dialog
 * @public
 */
export const OpenWithIcon = /* @__PURE__ */ Object.assign(
  OpenWithIconComponent,
  { displayName: 'OpenWithIcon' },
);
